export default __webpack_public_path__ + "static/media/right_label.6f5099b2.svg";